import { render, staticRenderFns } from "./OrganisationSidebarPlaceholder.vue?vue&type=template&id=d91f353e&scoped=true"
import script from "./OrganisationSidebarPlaceholder.vue?vue&type=script&lang=js"
export * from "./OrganisationSidebarPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./OrganisationSidebarPlaceholder.vue?vue&type=style&index=0&id=d91f353e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91f353e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d91f353e')) {
      api.createRecord('d91f353e', component.options)
    } else {
      api.reload('d91f353e', component.options)
    }
    module.hot.accept("./OrganisationSidebarPlaceholder.vue?vue&type=template&id=d91f353e&scoped=true", function () {
      api.rerender('d91f353e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationSidebarPlaceholder.vue"
export default component.exports